module.exports = __webpack_public_path__ + "img/86.aea622b.png";